import { PronosticoHistoricoElementAPI } from '@/domain/entities/Api'
import { MutationTree } from 'vuex'
import { PronosticoHistoricoState, StoreError } from './types'

export const mutations: MutationTree<PronosticoHistoricoState> = {
  PRONOSTICO_HISTORICO_FETCHED (state, payload: PronosticoHistoricoElementAPI[]) {
    state.error = { state: false }
    state.pronosticoHistorico = payload
    state.isLoaded = true
  },
  PRONOSTICO_HISTORICO_ERROR (state, payload: StoreError) {
    state.error = payload
  },
  PRONOSTICO_HISTORICO_SET_API_DESCARGA (state, payload: string) {
    state.link_descarga = payload
  },
  PRONOSTICO_HISTORICO_DELETED (state) {
    state.error = { state: false }
    state.pronosticoHistorico = []
  }
}
